import Betalingspaakrav from './Betalingspaakrav.js';
export default Betalingspaakrav;
//# sourceMappingURL=index.js.map